<template>
  <g fill-rule="evenodd">
    <path d="M15 0a15 15 0 100 30 15 15 0 000-30z" class="secondary-color" />
    <path
      d="M20.52 17.97a1.8 1.8 0 11-2.55 2.55L15 17.55l-2.97 2.97a1.8 1.8 0 01-2.55 0 1.8 1.8 0 010-2.55L12.45 15l-2.97-2.97a1.8 1.8 0 112.55-2.55L15 12.45l2.97-2.97a1.8 1.8 0 012.55 2.55L17.55 15l2.97 2.97z"
      fill="#FFF"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CloseIcon",
});
</script>
